module.exports = __webpack_public_path__ + "img/file_medical_plus_white.e2c857db.png";